import script from "./SocnetButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./SocnetButtons.vue?vue&type=script&setup=true&lang=ts"

import "./SocnetButtons.vue?vue&type=style&index=0&id=5f3ccdd4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f3ccdd4"]])

export default __exports__